import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./entrada.css";

const TIPO_SOLICITANTE = "SOLICITANTE";
const TIPO_ANALISTA = "ANALISTA";

export default function HomePage() {
    const [tipo, setTipo] = useState(TIPO_SOLICITANTE);
    const history = useHistory();

    function handleContinuar(e) {
        e.preventDefault();
        if (tipo === TIPO_SOLICITANTE) {
            history.push("/Solicitante");
        } else {
            history.push("/login");
        }
    }

    return (
        <div className="login-page entrada-page-nivvo">
            <section className="login-brand">
                <span className="login-orb login-orb--1" aria-hidden="true" />
                <span className="login-orb login-orb--2" aria-hidden="true" />
                <div className="login-brand-inner">
                    <img src="/Images/TACOMA_LOGO_NOVA.png" alt="Tacoma" className="login-logo" />
                    <p className="login-tagline">Bem-vindo ao Tacoma. Central de atendimento e chamados da sua empresa. Selecione como deseja acessar.</p>
                    <ul className="login-features">
                        <li><i className="fas fa-bolt" /> Abertura e acompanhamento ágil</li>
                        <li><i className="fas fa-clock-rotate-left" /> Histórico completo dos chamados</li>
                        <li><i className="fas fa-comments" /> Comunicação direta com o time</li>
                    </ul>
                </div>
            </section>
            <div className="login-form-wrap">
                <div className="login-form-card">
                    <h2>Como deseja acessar?</h2>
                    <p className="subtitle">Selecione o tipo de acesso e clique em Continuar</p>
                    <form onSubmit={handleContinuar}>
                        <div className="entrada-selector">
                            <label className={`entrada-option ${tipo === TIPO_SOLICITANTE ? "entrada-option--selected" : ""}`}>
                                <input
                                    type="radio"
                                    name="tipo"
                                    value={TIPO_SOLICITANTE}
                                    checked={tipo === TIPO_SOLICITANTE}
                                    onChange={() => setTipo(TIPO_SOLICITANTE)}
                                    className="entrada-option-input"
                                />
                                <span className="entrada-option-icon"><i className="fas fa-user" /></span>
                                <span className="entrada-option-text">
                                    <span className="entrada-option-label">Solicitante</span>
                                    <small className="entrada-option-desc">Abrir e acompanhar chamados</small>
                                </span>
                            </label>
                            <label className={`entrada-option ${tipo === TIPO_ANALISTA ? "entrada-option--selected" : ""}`}>
                                <input
                                    type="radio"
                                    name="tipo"
                                    value={TIPO_ANALISTA}
                                    checked={tipo === TIPO_ANALISTA}
                                    onChange={() => setTipo(TIPO_ANALISTA)}
                                    className="entrada-option-input"
                                />
                                <span className="entrada-option-icon"><i className="fas fa-user-shield" /></span>
                                <span className="entrada-option-text">
                                    <span className="entrada-option-label">Analista</span>
                                    <small className="entrada-option-desc">Área restrita para atendentes</small>
                                </span>
                            </label>
                        </div>
                        <button type="submit" className="login-submit">
                            Continuar <i className="fas fa-arrow-right" />
                        </button>
                    </form>
                    <footer className="login-footer">
                        &copy; Desenvolvido por Softbridge · {new Date().getFullYear()}
                    </footer>
                </div>
            </div>
        </div>
    );
}
